import React, { Component } from 'react';
import PropTypes from 'prop-types'
import withDonate from '../../components/guest/WithDonate';
import TeslaForm from './teslaForm';
import { loadProgressiveOnboarding } from '../../utility/lazyLoader';
let SignupApp;
let signUpAppEvents;
let Progressiveonboarding;

export class TeslaFormContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			progressiveComponentLoaded: false
		}
	}
	componentDidMount() {
		this.props.toggleSpinner(true);
		this.lazyLoadProgressiveComponent();
	}

	lazyLoadProgressiveComponent = () => {
		loadProgressiveOnboarding()
			.then((loadedModules) => {
				Progressiveonboarding = loadedModules[0];
				SignupApp = Progressiveonboarding.SignupApp;
				signUpAppEvents = Progressiveonboarding.clientListeners;
				this.setState({
					progressiveComponentLoaded: true
				});
			})
	};

	render() {
		if (!this.state.progressiveComponentLoaded) {
			return null;
		}

		return (
			<TeslaForm
				signupApp={SignupApp}
				signUpAppEvents={signUpAppEvents}
				{...this.props}
			/>
		);
	}
}

TeslaFormContainer.propTypes = {
	toggleSpinner: PropTypes.func
}

export default withDonate(TeslaFormContainer);



// WEBPACK FOOTER //
// ./pages/guest/teslaFormContainer.js